import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class subHeader_template extends vnTemplate{

    protected getTemplateHtml(): string {

        return `

                <div class="w-alert-banner-group">
                    <!-- ko if: maintenanceHtml() != null -->
                        <aside class="w-alert-banner info">
                            <div class="alert-banner-inner">
                                <p class="alert-banner-title">Sentinel Maintenance:</p>
                                <div class="alert-banner-content" data-bind="html: maintenanceHtml()"></div>
                            </div>
                        </aside>
                    <!-- /ko -->

                    <!-- ko if: pixelAlert().isInstalled != true && pixelAlert().isOwner -->
                        <aside class="w-alert-banner info">
                            <div class="alert-banner-inner">
                                <div class="alert-banner-content">
                                    <p>Your tracking code hasn't been installed yet onto one of your properties. <a data-bind="attr: { href: '/account_settings/'}">Click Here</a> to locate your tracking code and installation instructions.</p>
                                </div>
                            </div>
                        </aside>
                    <!-- /ko -->              
                </div>
            `;
    }

    protected initPartial(): void {

    }

    protected getTemplateName(): string{
        return "subHeader-template";
    }

    protected getMainElementClasses(): Array<string>{
        return ["w-justify"];
    }

    protected buildViewModel(): any{

        // define the viewmodel data/ functions
        let self = this;
        return  {
                    maintenanceHtml: ko.observable(null),
                    pixelAlert: ko.observable({
                        isInstalled: true,
                        isOwner: true
                    }),
                };
    }

    public setMaintenanceHtml(maintenanceHtml: string){

        this.getTemplateViewModel().maintenanceHtml(maintenanceHtml);
    }

    public setPixelAlert(pixelAlert: any){

        this.getTemplateViewModel().pixelAlert(pixelAlert);
    }
}



// WEBPACK FOOTER //
// ./js/components/templates/subHeader_template.ts